import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'fusion-ms-bar-chart',
  templateUrl: './ms-bar-chart.component.html',
  styleUrls: ['./ms-bar-chart.component.scss']
})
export class FusionMSBarChartComponent implements OnInit, OnChanges {
  @Input() chartCaption?: string;
  @Input() xaxisCatgoryList: string[];
  @Input() dataSeries: any[];
  @Input() height?: string = '200px';
  @Input() showvalues?: string = '1';
  @Input() xAxisName?: string = '';
  @Input() yAxisName?: string = '';
  @Input() numberSuffix?: string = '';

  /*

    Category Sample Object 
    {
      label: 'abc'
    }

    Data Series Sample Object
    {
      seriesname: "Original",
      color: "#ff0000",
      data: []
    }

    Data Series Data Sample Object 
    {
      value: 123
    }
  */

  dataSource: any = {
    chart: {
      caption: "",
      theme: "fusion",
      labelDisplay: "rotate",
      slantLabel: "1",
      maxLabelHeight: "100",
      chartLeftMargin: "5",
      chartRightMargin: "5",
      chartBottomMargin: "0",
      canvasPadding: "0",
      showBorder: "1",
      borderColor: "#8D009D",
      borderThickness: "2",
      borderAlpha: "20",
      plotHighlightEffect: "fadeout",
      legendPosition: "top-left",
      // legendPosition: "absolute",
      // legendXPosition: "40",
      // legendYPosition: "5",
      showvalues: this.showvalues,
    },
    categories: [{
      category: []
    }],
    dataset: [
      {
        data: []
      }
    ]
  };

  chartConfig: Object = {
    type: 'scrollbar2d',
    dataFormat: 'json',
  };


  constructor() {

  }

  ngOnInit() {
    this.initChartDataSource();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initChartDataSource();
  }

  initChartDataSource() {
    this.dataSource.chart.caption = this.chartCaption;
    this.dataSource.chart.showvalues = this.showvalues;
    this.dataSource.chart.xAxisName = this.xAxisName;
    this.dataSource.chart.yAxisName = this.yAxisName;
    this.dataSource.chart.numberSuffix = this.numberSuffix;
    this.dataSource.categories[0].category = this.xaxisCatgoryList;
    const dataset = []
    this.dataSeries.length && this.dataSeries[0].data.forEach(element => {
      dataset.push({value: "" + element.value});
    });
    this.dataSource.dataset[0].data = dataset;
  }

}
